var TranslationUtilityService = /** @class */ (function () {
    function TranslationUtilityService() {
    }
    TranslationUtilityService.splitByPlaceholder = function (key, placeholder) {
        if (placeholder === void 0) { placeholder = '%LINK%'; }
        var _a = key.toString().split(placeholder), before = _a[0], after = _a[1];
        return { before: before, after: after };
    };
    return TranslationUtilityService;
}());
export default TranslationUtilityService;
